import { useQuery } from '@tanstack/react-query';

import PriceParrotService from '~/services/PriceParrotService';

import type { CompetitorSourceName } from '~/types/services/priceParrot';

import { competitorOffersQueryKeys } from './competitorOffersQueryKeys';

export function useGetCompetitorPropertySnapshot(
  sourceName: CompetitorSourceName,
  externalPropertyId: string,
  collectionId: string | undefined,
) {
  return useQuery({
    queryKey: competitorOffersQueryKeys.snapshot(sourceName, externalPropertyId, collectionId ?? ''),
    queryFn: async ({ signal }) =>
      (
        await PriceParrotService.getCompetitorPropertySnapshot(
          sourceName,
          externalPropertyId,
          collectionId as string,
          signal,
        )
      ).data,
    enabled: !!collectionId,
  });
}
